<template>
  <div class="col">
    <div id="main" class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">
                Ealing Trailfinders Cricket Club Committee
              </h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
                The Management Committee are the team responsible for overseeing
                the growth, development, and administration of the cricket club.
                They take a keen interest in what happens on and off the pitch
                for both our senior and junior members. The team aligns with the
                directives and guidance of the ECB, Middlesex Cricket Board,
                Middlesex County Cricket Leagues and Middlesex Junior Cricket
                Association.
              </p>
              <p class="h5">
                The club is managed in accordance with the club’s Constitution
                and other adopted policies that form a part of the ECB Clubmark
                standards and accreditation. The Management Committee and adult
                team captains are elected by the members at our Annual General
                Meeting when reports on the year, including the annual accounts,
                are presented
              </p>
              <p class="h5">ECB Clubmark</p>
              <p class="h5">
                ECB Clubmark is an accreditation scheme for cricket clubs which
                shows that a club is sustainable, well run and provides the
                right environment for its members. Clubmark accreditation also
                means your club is recognised as a safe, rewarding and
                fulfilling place for participants of all ages, as well as
                assuring parents and carers that they are choosing the right
                option for their young people.
              </p>
            </div>

            <div class="col-12 col-lg-9">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <h4 class="my-4">The Management Committee consists of:</h4>

                  <div
                    v-for="member in members"
                    v-bind:key="member.sort_order"
                    class="row no-gutters bg-light mb-4 has-hover-s1"
                  >
                    <!-- image -->
                    <div class="col-6 col-sm-5 m-auto col-md-3 m-md-0 p-3">
                      <figure class="avatar bg-white">
                        <b-img-lazy
                          v-if="member.image"
                          :src="member.image"
                          alt="profile_image"
                          class=""
                        />
                        <b-img-lazy
                          v-else
                          src="../../assets/img/anime3.png"
                          alt="profile_image"
                          class=""
                        />
                      </figure>
                    </div>

                    <!-- text -->
                    <div class="col-12 col-md-9 p-3">
                      <div class="card bg-transparent">
                        <div class="card-body p-0">
                          <ul class="list-unstyled">
                            <li>
                              <h5 class="mt-3 m-0">
                                {{ member.members_name }}
                              </h5>
                            </li>
                            <li>
                              <h6 class="text-normal">{{ member.title }}</h6>
                            </li>
                            <li>
                              <nav class="nav justify-content-start">
                                <a
                                  class="btn btn-more btn-more-outline btn-more-sm py-3 px-1"
                                  v-bind:href="member.email"
                                  ><i class="material-icons">email</i></a
                                >
                                <a
                                  v-if="member.contact_number"
                                  class="btn btn-more btn-more-outline btn-more-sm py-3 px-1"
                                  v-bind:href="'tel:' + formatPhoneNumber(member.contact_number)"
                                  ><i class="material-icons">call</i></a
                                >
                              </nav>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="list-group-item">
                  <h4 class="my-4">Qualified Trailfinders Coaches:</h4>
                  <p>
                    We also have a number of fully qualified coaches at the
                    club.
                    <a v-bind:href="'#/our-coaches'" class="text-dark"
                      >Find more about who we’ve chosen</a
                    >
                    to shape the future of Trailfinders Cricket Club.
                  </p>
                  <!-- Btn -->
                  <div class="row justify-content-between mt-4">
                    <div class="col-auto">
                      <a
                        v-bind:href="'#/our-coaches'"
                        class="btn btn-more btn-has-icon-left"
                        ><i class="material-icons">arrow_forward</i>Trailfinders
                        Coaches</a
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCommitteeMembers } from "@/services/api";
import formatPhoneNumber from "@/utils/formatPhoneNumber";

export default {
  data() {
    return {
      members: [],
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      fetchCommitteeMembers().then((response) => {
        this.members = response;
      });
    },
    formatPhoneNumber,
  },
};
</script>
